import React, { PropTypes } from 'react';
import Modal from "../../../Modal";
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { smtpConfig as api } from "../../api";
import Form, { FormActions, FormBody, TextInput } from "../../../Form";
import { token } from "../../../../libs/localStorage";
import Button from '../../../Form/Button';

@inject('userStore')
@observer
export default class SmtpTest extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/email';

  @observable item = {
    to: '',
    subject: '',
    message: '',
  };
  @observable isLoading = false;

  @action onChangeTo = e => this.item.to = e.target.value;
  @action onChangeSubject = e => this.item.subject = e.target.value;
  @action onChangeMessage = e => this.item.message = e.target.value;

  handleSend = (e) => {
    e.preventDefault();
    const { router, notify } = this.context;
    let sender = this.props.userStore.findById(token.getDecoded().id).asJson;
    this.item.sender = { name: sender.name, email: sender.email };
    this.isLoading = true;
    api.test(this.item)
      .then(res => {
        notify.success(res);
        router.push(this.slug);
      })
      .catch(() => notify.error({ message: "Mail is not sent " }))
      .finally(() => this.isLoading = false);
  };

  render() {
    return (
      <Modal slug={this.slug} title='Test SMTP'>
        <Form>
          <FormBody>
            <TextInput label='To' value={this.item.to} onChange={this.onChangeTo} />
            <TextInput label='Subject' value={this.item.subject} onChange={this.onChangeSubject} />
            <TextInput label='Message' value={this.item.message} onChange={this.onChangeMessage} />
          </FormBody>

          <FormActions>
            <Button label={'Send'} onClick={this.handleSend} isLoading={this.isLoading} />
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Email/SmtpTest.js